module.exports = __webpack_public_path__ + "static/media/hexaBoldBg.8b266914.png";